import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/host/stores/auth.store';
import OrganizationLeave from '../welcome/components/OrganizationLeave';
import { useSessionStore } from '../stores';

const getOrgSlugFromPath = (pathname: string): string | null => {
  const match = /^\/([^/]+)/.exec(pathname);
  return match ? match[1] : null;
};

export const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useAuthStore((s) => s.user);
  const sessionId = useSessionStore((s) => s.sessionId);
  const { getToken, signOut, authenticateRocketChatUser } = useAuthStore.getState();

  const location = useLocation();
  const orgSlug = getOrgSlugFromPath(location.pathname);
  const storedOrgSlug = localStorage.getItem('org-slug');
  const welcomeRedirect = orgSlug ? `/${orgSlug}/welcome` : '/welcome';

  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  const leavingOrganization = () => {
    return sessionId && authenticated && storedOrgSlug && orgSlug && storedOrgSlug !== orgSlug;
  };

  useEffect(() => {
    setChecking(true);
    const verify = async () => {
      const token = await getToken();
      // For normal users, only check if token exists (don't check expiration)
      // Cognito handles token refresh automatically via Amplify
      const valid = !!token;
      if (!valid) {
        await signOut();
        setAuthenticated(false);
      } else {
        authenticateRocketChatUser();
        setAuthenticated(true);
      }
      setChecking(false);
    };
    verify();
  }, [getToken, signOut, user]);

  if (checking) return <div>Loading...</div>;

  if (leavingOrganization()) {
    return <OrganizationLeave />;
  }

  if (!authenticated) {
    return <Navigate to={welcomeRedirect} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
